import styled from "@emotion/styled";
import { CSS_MQ } from "../../../../../styles/breakpoints";

export const CheckoutVisualButtonGroup = styled.div`
  display: flex;
  flex-direction: column;

  gap: 10px;
  ${CSS_MQ.atLeastMd} {
    gap: 15px;
  }
`;
